// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/flat-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*----------------------------------------
    Login Page
------------------------------------------*/
.Login_login-bg__hE6-5
{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
}

#Login_login-page__vY2fL
{
    display:         flex;

    height: 100vh;
    justify-content: center;
    align-items: center;
}

#Login_login-page__vY2fL .Login_card-panel__wlMm4.Login_border-radius-6__zsCYA.Login_login-card__Qbmc2
{
    margin-left: 0 !important;
}

.Login_styleText__OThnh {
    font-size: 1rem !important;
    box-sizing: content-box !important;
    width: 30% ;
    height: 30px !important;
    margin: 0 0 8px 0 !important;
    margin-left: 8px !important;
    padding: 4px !important;
    transition: box-shadow .3s, border .3s !important;
    border: none !important;
    border-bottom: 1px solid #9e9e9e !important;
    border-radius: 0 !important;
    outline: none !important;
    box-shadow: none !important;
    text-align: center !important;
    border: 1px solid rgb(141, 141, 141) !important;
    border-radius: 5px !important;
}

.Login_materialiconslogin__X-rKo {
    font-family: 'Material Icons';
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 1;
    display: inline-block;
    white-space: nowrap;
    letter-spacing: normal;
    text-transform: none;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'liga';
}

.Login_input-field__SWKD7 .Login_prefix__sM3Gs {
    font-size: 2rem;
    position: absolute;
    top: 0.5rem !important;
    width: 3rem;
    transition: color .2s;
}

.Login_pt-2__ZjkKr {
    padding-top: 2% !important;
}

#Login_bottonlogin__aWNaH {
    line-height: 15px !important;
    display: inline-block !important;
    height: 40px !important;
    width: auto !important;
    padding: 10px !important;
    vertical-align: middle !important;
    text-transform: unset !important;
    border: none !important;
    border-radius: 2px !important;
    -webkit-tap-highlight-color: transparent !important;
    margin-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/css/Login.module.css"],"names":[],"mappings":"AAAA;;2CAE2C;AAC3C;;IAEI,yDAAiD;IACjD,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;;IAKI,qBAAqB;;IAErB,aAAa;IAKL,uBAAuB;IAIvB,mBAAmB;AAC/B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,iDAAiD;IACjD,uBAAuB;IACvB,2CAA2C;IAC3C,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;IAC3B,6BAA6B;IAC7B,+CAA+C;IAC/C,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;IAClC,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;IACjC,gCAAgC;IAChC,uBAAuB;IACvB,6BAA6B;IAC7B,mDAAmD;IACnD,iBAAiB;AACrB","sourcesContent":["/*----------------------------------------\n    Login Page\n------------------------------------------*/\n.login-bg\n{\n    background-image: url('../../public/flat-bg.jpg');\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n#login-page\n{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display:         flex;\n\n    height: 100vh;\n\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n            align-items: center;\n}\n\n#login-page .card-panel.border-radius-6.login-card\n{\n    margin-left: 0 !important;\n}\n\n.styleText {\n    font-size: 1rem !important;\n    box-sizing: content-box !important;\n    width: 30% ;\n    height: 30px !important;\n    margin: 0 0 8px 0 !important;\n    margin-left: 8px !important;\n    padding: 4px !important;\n    transition: box-shadow .3s, border .3s !important;\n    border: none !important;\n    border-bottom: 1px solid #9e9e9e !important;\n    border-radius: 0 !important;\n    outline: none !important;\n    box-shadow: none !important;\n    text-align: center !important;\n    border: 1px solid rgb(141, 141, 141) !important;\n    border-radius: 5px !important;\n}\n\n.materialiconslogin {\n    font-family: 'Material Icons';\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    line-height: 1;\n    display: inline-block;\n    white-space: nowrap;\n    letter-spacing: normal;\n    text-transform: none;\n    word-wrap: normal;\n    direction: ltr;\n    -webkit-font-smoothing: antialiased;\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    font-feature-settings: 'liga';\n}\n\n.input-field .prefix {\n    font-size: 2rem;\n    position: absolute;\n    top: 0.5rem !important;\n    width: 3rem;\n    transition: color .2s;\n}\n\n.pt-2 {\n    padding-top: 2% !important;\n}\n\n#bottonlogin {\n    line-height: 15px !important;\n    display: inline-block !important;\n    height: 40px !important;\n    width: auto !important;\n    padding: 10px !important;\n    vertical-align: middle !important;\n    text-transform: unset !important;\n    border: none !important;\n    border-radius: 2px !important;\n    -webkit-tap-highlight-color: transparent !important;\n    margin-left: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-bg": `Login_login-bg__hE6-5`,
	"login-page": `Login_login-page__vY2fL`,
	"card-panel": `Login_card-panel__wlMm4`,
	"border-radius-6": `Login_border-radius-6__zsCYA`,
	"login-card": `Login_login-card__Qbmc2`,
	"styleText": `Login_styleText__OThnh`,
	"materialiconslogin": `Login_materialiconslogin__X-rKo`,
	"input-field": `Login_input-field__SWKD7`,
	"prefix": `Login_prefix__sM3Gs`,
	"pt-2": `Login_pt-2__ZjkKr`,
	"bottonlogin": `Login_bottonlogin__aWNaH`
};
export default ___CSS_LOADER_EXPORT___;
